<script setup lang="ts">
/**
 * @todo Old surveys after the update have an empty 'Other' questionText so we need to put something together.
 * Note that multi questions have children as well, though, and they'll also have empty questionText.
 * Checking for text length AND !multiQuestion is a hacky way to get around this but works for now.
 */
import {reactive, watch, onMounted, ref} from 'vue';

import BrandInput from '@/components/BrandInput.vue';

import { QuestionModel } from '../types';
const props = defineProps<{
  question: QuestionModel;
  isChildQuestion?: boolean;
  multiQuestion?: boolean;
}>();

const emit = defineEmits(['answerChanged']);
const spacing = ref('mb-16');

const data = reactive({
  model: props.question,
  isChildQuestion: props.isChildQuestion,
});
if (data.model.answer === undefined)
  data.model.answer = { id: props.question.id, answer: '', displayText: '' };

onMounted(() => {
  if (props.isChildQuestion) spacing.value = 'mb-8';
  else if (props.multiQuestion) spacing.value = 'mb-4';
});

watch(
  () => data.model.answer?.answer,
  () => {
    if (!data.model.answer) return;
    data.model.answer.answer = String(data.model.answer.answer);
    emit('answerChanged', data.model.answer);
  },
);
</script>
<template>
  <div
    class="text-left w-full"
    :class="spacing"
    v-if="data.model && data.model.answer && typeof data.model.answer.answer === 'string'"
  >
    <p v-if="!multiQuestion" class="mb-2 font-bold whitespace-pre-line">
      {{ data.model.questionText.length ? data.model.questionText : 'Other, please specify' }}
      <span v-if="data.model.mandatory && !data.isChildQuestion" class="text-red-500">*</span>
    </p>
    <label :for="data.model.id" class="block mb-4">{{ data.model.helperText }}</label>

    <BrandInput
      type="text"
      :id="data.model.id"
      class="inlineErrorInput bg-gray-50"
      :placeholder="data.model.placeholderText"
      v-model="data.model.answer.answer"
      maxlength="2000"
    />
  </div>
</template>
